var client = 'carmex'
var campaign = 'summer-campaign'
var form = document.getElementById('competition-form')
var fileName = "";

form.addEventListener('submit', function (e) {
  e.preventDefault()
  if (fileAdded() === true) {
    form.classList.add('loading')
    postImage(
      {
        file: form.file.files[0] || form.uploadFile.files[0],
      },
      function (response) {
          if (JSON.parse(response).success) {
            fileName = JSON.parse(response).fileName;
            var serializedForm = serializeArray(form);

            let campaignObject = {
              "name": "page",
              "value": campaign
            };

            let fileNameObject = {
              "name": "fileName",
              "value":fileName
            };

            serializedForm.push(fileNameObject, campaignObject);

            postToOrder(
              {
                values: JSON.stringify(serializedForm),
                client: client,
                testMode: false,
              },
              function (response) {
                if (JSON.parse(response).success) {
                  successFunction();
                  if (typeof fbq === 'function') {
                    fbq('track', 'Lead', {
                      content_name: campaign,
                      content_category: 'contest',
                    })
                  }
                } else {
                  form.classList.remove('loading')
                  form.classList.add('error')
                }
              }
            )
          } else {
            errorFunction(JSON.parse(response).message);
          }
        }
    )
  } else {
    document.getElementById('file-label').classList.add('error-btn')
    document.getElementById('upload-file-label').classList.add('error-btn')
    document.getElementById('no-file-added-error').style.display = 'block'
  }
})

// analyticalData({
//   client: client,
//   campaign: campaign,
// })

function fileAdded() {
  var fileInput = document.getElementById('file')
  var uploadFileInput = document.getElementById('upload-file')
  if ((fileInput.value !== '' && fileInput.value !== null && fileInput.value !== undefined) || (uploadFileInput.value !== '' && uploadFileInput.value !== null && uploadFileInput.value !== undefined)) {
    return true
  } else {
    return false
  }
}

function successFunction(message) {
  form.classList.add('success')
  form.classList.remove('loading')
}

function errorFunction(message) {
  form.classList.add('error')
  document.getElementById('error-message').style.display = 'block';
  document.getElementById('error-message').innerHTML = message;
}